export enum MessageTypes {
    "error" = "error",
    "info" = "info",
    "warning" = "warning",
    "success" = "success"
}

export type MessageType = MessageTypes.error | MessageTypes.info | MessageTypes.success | MessageTypes.warning;
